import React from "react";
import { RCCBadge } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";

interface IBadgeEfficiency{
    finished: boolean;
}

const BadgeEfficiency: React.FC<IBadgeEfficiency> = ({
	finished
}) => {
	const { translate } = useTranslation();
	return <RCCBadge color={finished ? "green" : "blue"} styleInline="padding: 2px 8px; font-size: 0.78rem;">
		{finished ? translate("Concluída") : translate("Em andamento")}
	</RCCBadge>
	;
};

export default BadgeEfficiency;
